import React from 'react';

const History_of_Intelligence = () => {
    return (
        <div>History_of_Intelligence Component</div>
    );
}

export default History_of_Intelligence;
